
import { BaseAPI } from "./BaseAPI";
import * as environment from '../config/environment';

class EmailAPI extends BaseAPI {


    constructor() {
        const baseUrl = environment.API_URL + "EmailService/send-code";
        super(baseUrl);
    }


    mailGonder(request: EmailRequest) {

        const isLogin = request.isLogin ? true : false;
        return this.post(`?isLogin=${isLogin}`, request);

    }

}
export default new EmailAPI();

class EmailRequest {
    email?: string;
    tcKimlikNo?: string;
    token?: string;
    vergiNo?: string;
    isLogin?:boolean;
    isKayit?:boolean;

    constructor(
        email?: string,
        tcKimlikNo?: string,
        token?: string,
        vergiNo?: string,
        isLogin?: boolean,
        isKayit?: boolean
    ) {
        this.email = email;
        this.tcKimlikNo = tcKimlikNo;
        this.token = token;
        this.vergiNo= vergiNo;
        this.isLogin= isLogin;
        this.isKayit= isKayit;
    }
}
export { EmailRequest };

